<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        FAQ - Question/Réponse
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="cancel"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <v-form
      ref="form"
      v-model="valid"
      class="mt-6"
    >
      <AgrialInput
        v-model="questionReponseModifiable.intitule"
        class="px-5"
        label="Intitulé de la question"
        :rules="[rules.required, rules.maxcaracteres]"
        required
      />
      <v-row no-gutters>
        <v-col
          align-self="center"
          cols="1"
        >
          <v-icon
            class="pl-5"
          >
            mdi-laptop
          </v-icon>
        </v-col>
        <v-col cols="11">
          <AgrialRichTextEditor
            v-model="questionReponseModifiable.reponseOrdinateur"
            class="px-5"
            placeholder-value="Saisissez votre réponse pour les ordinateurs"
            :rules="[rules.required]"
            @input="onUpdateReponseOrdinateur"
          />
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class="mt-4"
        justify="center"
      >
        <v-col
          align-self="center"
          cols="1"
        >
          <v-icon
            class="pl-5"
          >
            mdi-cellphone-sound
          </v-icon>
        </v-col>
        <v-col cols="11">
          <AgrialRichTextEditor
            v-model="questionReponseModifiable.reponseSmartphone"
            class="px-5"
            placeholder-value="Saisissez votre réponse pour les smartphones"
            :rules="[rules.required]"
            @input="onUpdateReponseSmartphone"
          />
        </v-col>
      </v-row>
      <AgrialSelect
        v-model="pageSelected"
        class="px-5 pt-5"
        :menu-props="{ top: true, offsetY: true }"
        :items="listePagesAdherentTrie"
        label="Page à mettre en lien"
        item-text="libelle"
        return-object
        @change="choixPageLien()"
      />
      <AgrialInput
        v-model="routePage"
        readonly
        class="px-5"
        label="Chemin à copier dans &quot;Enter link&quot;"
      />
      <v-row
        class="px-5 mb-2"
        no-gutters
      >
        <v-col
          cols="4"
          align-self="center"
        >
          <span class="intro text-gris-fonce">Nouveauté</span>
        </v-col>
        <v-col
          cols="7"
          align-self="center"
        >
          <AgrialSwitch
            v-model="questionReponseModifiable.nouveaute"
            label-off="Non"
            label-on="Oui"
            @input="setNouveaute()"
          />
        </v-col>
      </v-row>
      <v-row
        class="px-5 justify-space-between"
        no-gutters
      >
        <v-col
          v-if="isNouveaute"
          cols="6"
          class="pr-3"
          align-self="center"
        >
          <AgrialDatepicker
            v-model="questionReponseModifiable.dateDebutNouveaute"
            label="Date début"
            :rules="[rules.required, questionReponseModifiable.datFinNouveaute ? rules.dateDebutNouveaute : true, isNouveaute ? rules.required : true]"
            :min="borneDateDebutNouveaute.min"
            :max="borneDateDebutNouveaute.max"
          />
        </v-col>
        <v-col
          v-if="isNouveaute"
          cols="6"
          align-self="center"
        >
          <AgrialDatepicker
            v-model="questionReponseModifiable.dateFinNouveaute"
            label="Date fin"
            :rules="[questionReponseModifiable.dateDebutNouveaute ? rules.dateFinNouveaute : true, isNouveaute ? rules.required : true]"
            :min="borneDateFinNouveaute.min"
          />
        </v-col>
      </v-row>
    </v-form>
    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        @click="cancel"
      >
        Annuler
      </AgrButton>
      <AgrButton
        color="primary darken-1"
        :disabled="!valid || !questionReponseModifiable.reponseOrdinateur || !questionReponseModifiable.reponseSmartphone"
        @click="saveQuestionReponse"
      >
        Valider
      </AgrButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import AgrialInput from '@/components/form/agrial-input.vue'
import AgrialSwitch from '@/components/form/agrial-switch.vue'
import AgrialDatepicker from '@/components/form/agrial-datepicker.vue'
import AgrialRichTextEditor from '@/components/form/agrial-rich-text-editor.vue'
import AgrialSelect from '@/components/form/agrial-select.vue'
import { parse, isAfter, isBefore, isEqual, startOfDay } from 'date-fns'
import {clone} from '@/utils/clone'
import listePagesAdherent from '@/model/listePagesAdherent'
import { sortBy } from 'lodash'

export default {
  name: 'FaqQuestionReponseSaisie',
  components: { AgrButton, AgrialInput, AgrialSwitch, AgrialDatepicker, AgrialRichTextEditor, AgrialSelect },
  props: {
    questionReponse: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      questionReponseModifiable: {},
      valid: false,
      isNouveaute: false,
      rules: {
        required: v => !!v || 'Obligatoire',
        maxcaracteres: v => (!!v && v.length <= 80) || 'Question trop longue (80 caractères maximum)',
        dateDebutNouveaute: v => this.controleDateDebutNouveaute(v),
        dateFinNouveaute: v => this.controleDateFinNouveaute(v)
      },
      listePagesAdherent,
      pageSelected: null,
      routePage: null
    }
  },
  computed: {
    borneDateDebutNouveaute () {
      return {
        min: new Date(Date.now()),
        max: this.questionReponseModifiable.dateFinNouveaute ? this.questionReponseModifiable.dateFinNouveaute : ''
      }
    },
    borneDateFinNouveaute () {
      const dateDebutAControler = this.questionReponseModifiable.dateDebutNouveaute ? startOfDay(new Date(this.questionReponseModifiable.dateDebutNouveaute)) : startOfDay(new Date(Date.now()))
      const dateDebutNouveauteBeforeNow = isBefore(dateDebutAControler, new Date(Date.now()))
      return {
        min: !dateDebutNouveauteBeforeNow ? (this.questionReponseModifiable.dateDebutNouveaute ? this.questionReponseModifiable.dateDebutNouveaute : new Date(Date.now())) : new Date(Date.now())
      }
    },
    listePagesAdherentTrie () {
      return sortBy(listePagesAdherent, 'libelle')
    }
  },
  watch: {
    questionReponse: {
      handler () {
        this.questionReponseModifiable = clone(this.questionReponse)
        this.isNouveaute = this.questionReponseModifiable ? this.questionReponseModifiable.nouveaute : false
      },
      immediate: true
    }
  },

  methods: {
    cancel () {
      this.$emit('cancel')
    },

    saveQuestionReponse () {
      this.questionReponseModifiable.idTheme = this.questionReponse.idTheme
      this.$emit('saveQuestionReponse', this.questionReponseModifiable)
    },

    onUpdateReponseOrdinateur () {
      this.questionReponse.reponseOrdinateur = this.questionReponseModifiable.reponseOrdinateur
    },

    onUpdateReponseSmartphone () {
      this.questionReponse.reponseSmartphone = this.questionReponseModifiable.reponseSmartphone
    },

    setNouveaute () {
      this.isNouveaute = this.questionReponseModifiable.nouveaute
    },

    controleDateDebutNouveaute (v) {
      // si une date de fin de nouveauté est saisie, la date début doit être inférieure ou égale à la date de fin
      const dateAControler = parse(v, 'dd/MM/yyyy', new Date())
      const dateFinAControler = startOfDay(new Date(this.questionReponseModifiable.dateFinNouveaute))
      return (isEqual(dateAControler, dateFinAControler) || isBefore(dateAControler, dateFinAControler)) || `Doit être inférieure ou égale à la date de fin`
    },

    controleDateFinNouveaute (v) {
      // si une date début de nouveauté est saisie, la date de fin doit être supérieure ou égale à la date de début
      const dateAControler = parse(v, 'dd/MM/yyyy', new Date())
      const dateDebutAControler = startOfDay(new Date(this.questionReponseModifiable.dateDebutNouveaute))
      return (isEqual(dateAControler, dateDebutAControler) || isAfter(dateAControler, dateDebutAControler)) || `Doit être supérieure ou égale à la date de début`
    },

    choixPageLien () {
      return this.routePage = this.pageSelected.route
    }
  }
}
</script>

<style lang="scss" scoped>

.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>
